export const RESET_STATE = 'RESET_STATE';
export const REQUEST_LOADING = 'ROLES_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'ROLES_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'ROLES_REQUEST_FAILED';
export const UPDATE_CURRENCY = 'ROLES_UPDATE_CURRENCY';